import images from "../../global-styles/images";

export interface IProductInfo {
  apiKey?: string;
  apiKeyId?: string;
  id: string;
  groups?: string[];
  version: string;
  name: string;
  description?: string;
  logo?: string;
  platform: IPlatformType;
  technology?: string;
  orgId: string;
  createdOn?: number;
  createdBy?: string;
  lastModifiedOn?: number;
  lastModifiedBy?: string;
  feedbackAgentSettings?: IFeedbackAgentSettings;
  status: string;
  trackingSystem?: ITrackingSystem;
  emailConfig?: any;
  cloneNewVersion?: boolean;
  searchKey?: string;
  url?: string;
  knowledgeBaseUrl?: {
    [key: string]: string;
  };
  chatAgentSettings?: ChatAgentSettingIF;
  _id?: string;
  jiraSettings?: ITrackingSystem;
  zendeskSettings?: ITrackingSystem;
  cloneNewProduct?: boolean;
}

export type CHATBOT_GPT = "GPT";
export type CHATBOT_LAMA = "LAMA";

export type ChatbotLLMOptions = CHATBOT_GPT | CHATBOT_LAMA;

export interface intelligenceConfiguration {
  [key: string]: string | string[];
}
export interface ChatbotAISettingIF {
  llmArchitecture: string;
  tone: string;
  useEmoji: boolean;
  allowGeneralQuestions: boolean;
  lengthOfResponse: number;
  numberOfTriesBeforeRedirect: number;
  customerSupportResponse?: string;
  intelligenceLayer: intelligenceConfiguration[];
  aiCreativity: number;
  kbArticles: string[];
  openaiKey?: string;
  kbUrlSettings?: any;
}

export interface ChatbotBrandingIF {
  "cuvo-chatbot-body-bg-color": string;
  "cuvo-chatbot-footer-bg-color": string;
  "cuvo-chatbot-header-bg-color": string;
  "cuvo-chatbot-header-text-color": string;
  "cuvo-chatbot-header-text-font-family": string;
  "cuvo-chatbot-header-text-font-weight": string;
  "cuvo-chatbot-header-text-font-style": string;
  "cuvo-chatbot-header-text-font-size": string;
  "cuvo-chatbot-bot-bg-color": string;
  "cuvo-chatbot-bot-text-color": string;
  "cuvo-chatbot-bot-text-font-family": string;
  "cuvo-chatbot-bot-text-font-weight": string;
  "cuvo-chatbot-bot-text-font-style": string;
  "cuvo-chatbot-bot-text-font-size": string;
  "cuvo-chatbot-user-bg-color": string;
  "cuvo-chatbot-user-text-color": string;
  "cuvo-chatbot-user-text-font-family": string;
  "cuvo-chatbot-user-text-font-weight": string;
  "cuvo-chatbot-user-text-font-style": string;
  "cuvo-chatbot-user-text-font-size": string;
  "cuvo-chatbot-input-bg-color": string;
  "cuvo-chatbot-input-text-color": string;
  "cuvo-chatbot-input-text-font-family": string;
  "cuvo-chatbot-input-text-font-weight": string;
  "cuvo-chatbot-input-text-font-style": string;
  "cuvo-chatbot-input-text-font-size": string;
  "cuvo-chatbot-send-icon-fg-color": string;
  "cuvo-chatbot-send-icon-bg-color": string;
  "cuvo-chatbot-bot-icon-fg-color": string;
  "cuvo-chatbot-bot-icon-bg-color": string;
  "cuvo-chatbot-primary-button-bg-color": string;
  "cuvo-chatbot-primary-button-text-color": string;
  "cuvo-chatbot-primary-button-text-font-family": string;
  "cuvo-chatbot-primary-button-text-font-style": string;
  "cuvo-chatbot-primary-button-text-font-weight": string;
  "cuvo-chatbot-primary-button-text-font-size": string;
  "cuvo-chatbot-secondary-button-bg-color": string;
  "cuvo-chatbot-secondary-button-text-color": string;
  "cuvo-chatbot-secondary-button-text-font-family": string;
  "cuvo-chatbot-secondary-button-text-font-style": string;
  "cuvo-chatbot-secondary-button-text-font-weight": string;
  "cuvo-chatbot-secondary-button-text-font-size": string;
}

export interface ChatAgentSettingIF {
  // backIcon: any;
  // backIconReq: any;
  sendIconReq?: any;
  chatbotIconReq?: any;
  chatIconReq?: any;
  name: string;
  chatbotIcon?: any;
  chatIcon?: any;
  welcomeMsg?: string;
  sendIcon?: any;
  sessionTimeout?: number;
  // branding?: ChatbotBrandingIF;
  aiSetting?: ChatbotAISettingIF;
}

export interface ITesterStatus {
  id: string;
  approved: boolean;
}

export interface IFeedbackAgentSettings {
  //  platform: IPlatformType;
  feedbackTypes: IFeedbackType[];
  logo?: string;
  showLogo?: boolean;
  invokeDelay?: number; //in minutes
  invokeOn: IInvokeType[];
  disableDefaultBtn: boolean;
  disableCuvo: boolean;
  thanksStr?: string;
  title: string;
  subtitle?: string;
  uploadFileMaxSize: string; //in MB, allowed values 200, 400, 600, 800 or 1024
  videoAudioMaxDuration: string; //in min, allowed values 0.5, 1, 1.5, 2, 2.5 or 3
  requireEmail?: boolean;
  captureSystemDetails?: boolean;
  remoteBtns: IRemoteBtnSettings[];
  widgetLookAndFeel: IWidgetLAF;
  bugSettings?: IBugSettings;
  feedbackSettings?: IFeedbackSettings;
  featureReqSettings?: IFeatureReqSettings;
  bannerType?: string;
  bannerImage?: string;
  bannerText?: string;
  bannerImageReq?: any;
  logoReq?: any;
  branding?: brandingIF;
  qrSettings?: IQRSettings;
}
export interface IQRSettings {
  addQR?: boolean;
  qrHeading?: string;
  qrSubHeading?: string;
}

export interface brandingIF {
  "branding-cuvo-popup-dialog-agent-bg"?: any;
  "branding-cuvo-popup-dialog-main-title"?: any;
  "branding-cuvo-popup-dialog-main-title-font-family"?: any;
  "branding-cuvo-popup-dialog-main-title-font-weight"?: any;
  "branding-cuvo-popup-dialog-main-title-font-style"?: any;
  "branding-cuvo-popup-dialog-main-title-font-size"?: any;
  "branding-cuvo-popup-dialog-main-subtitle"?: any;
  "branding-cuvo-popup-dialog-main-subtitle-font-family"?: any;
  "branding-cuvo-popup-dialog-main-subtitle-font-weight"?: any;
  "branding-cuvo-popup-dialog-main-subtitle-font-style"?: any;
  "branding-cuvo-popup-dialog-main-subtitle-font-size"?: any;
  "branding-cuvo-popup-dialog-card-bg"?: any;
  "branding-cuvo-popup-dialog-card-title"?: any;
  "branding-cuvo-popup-dialog-card-title-font-family"?: any;
  "branding-cuvo-popup-dialog-card-title-font-weight"?: any;
  "branding-cuvo-popup-dialog-card-title-font-style"?: any;
  "branding-cuvo-popup-dialog-card-title-font-size"?: any;
  "branding-cuvo-popup-dialog-card-subtitle"?: any;
  "branding-cuvo-popup-dialog-card-subtitle-font-family"?: any;
  "branding-cuvo-popup-dialog-card-subtitle-font-weight"?: any;
  "branding-cuvo-popup-dialog-card-subtitle-font-style"?: any;
  "branding-cuvo-popup-dialog-card-subtitle-font-size"?: any;
  "branding-cuvo-primary-button-bg"?: any;
  "branding-cuvo-primary-button-text-color"?: any;
  "branding-cuvo-primary-button-text-font-family"?: any;
  "branding-cuvo-primary-button-text-font-style"?: any;
  "branding-cuvo-primary-button-text-font-weight"?: any;
  "branding-cuvo-primary-button-text-font-size"?: any;
  "branding-cuvo-primary-button-border-color"?: any;
  "branding-cuvo-secondary-button-bg"?: any;
  "branding-cuvo-secondary-button-text-color"?: any;
  "branding-cuvo-secondary-button-text-font-family"?: any;
  "branding-cuvo-secondary-button-text-font-style"?: any;
  "branding-cuvo-secondary-button-text-font-weight"?: any;
  "branding-cuvo-secondary-button-text-font-size"?: any;
  "branding-cuvo-secondary-button-border-color"?: any;
  // "branding-cuvo-card-border-color"?: any;
  // "branding-cuvo-card-border-radius"?: any;
  // "branding-cuvo-button-border-radius"?: any;
  "branding-cuvo-input-label-color"?: any;
  "branding-cuvo-input-label-font-family"?: any;
  "branding-cuvo-input-label-font-style"?: any;
  "branding-cuvo-input-label-font-weight"?: any;
  "branding-cuvo-input-label-font-size"?: any;
  "branding-cuvo-input-field-text-color"?: any;
  "branding-cuvo-input-field-bg-color"?: any;
  "branding-cuvo-attachment-helper-color"?: any;
  "branding-cuvo-attachment-helper-font-family"?: any;
  "branding-cuvo-attachment-helper-font-style"?: any;
  "branding-cuvo-attachment-helper-font-weight"?: any;
  "branding-cuvo-attachment-helper-font-size"?: any;
  "branding-cuvo-card-svg-fg-color"?: any;
  "branding-cuvo-card-svg-bg-color"?: any;
  "branding-cuvo-selected-star-color"?: any;
  "branding-cuvo-unselected-star-color"?: any;
  "branding-cuvo-card-border-color"?: any;
  "branding-cuvo-input-border-color"?: any;
  "branding-cuvo-input-border-radius"?: any;
  "branding-cuvo-card-border-radius"?: any;
  "branding-cuvo-comments-field-height"?: any;
  "branding-cuvo-editor-font-size"?: any;
  "branding-cuvo-editor-font-family"?: any;
  "branding-cuvo-primary_btn-border-radius"?: any;
  "branding-cuvo-secondary_btn-border-radius"?: any;
  "branding-cuvo-selected-start-rating-uri"?: any;
  "branding-cuvo-unselected-start-rating-uri"?: any;
}

export interface IBugSettings {
  categories: ICategory[];
  severities: string[];
  categoryHeading?: string;
  severityHeading?: string;
  stdFeedbackHeading?: string;
  generalCommentsHeading?: string;
  attachmentHelp?: string;
  dialogMsg?: string;
  thanksMsg?: string;
  icon?: string;
  iconReq?: any;
  deleteFileName?: string;
  title?: string;
  tooltip?: string;
  reqComments: boolean;
  reqDisplayEmail?: boolean;
  showSeverity: boolean;
  reqCategory: boolean;
}

export interface IFeedbackSettings {
  type: IFeedbackFlowType;
  categories: ICategory[];
  ratingIcon: IRatingIconType;
  ratingLimit: number; //values 1,2,3,4,5
  categoryHeading?: string;
  ratingHeading?: string;
  stdFeedbackHeading?: string;
  generalCommentsHeading?: string;
  attachmentHelp?: string;
  dialogMsg?: string;
  thanksMsg?: string;
  icon?: string;
  iconReq?: any;
  title?: string;
  tooltip?: string;
  reqComments: boolean;
  reqDisplayEmail?: boolean;
  reqCategory: boolean;
}

export interface IFeatureReqSettings {
  categories: ICategory[];
  categoryHeading?: string;
  stdFeedbackHeading?: string;
  generalCommentsHeading?: string;
  attachmentHelp?: string;
  dialogMsg?: string;
  thanksMsg?: string;
  icon?: string;
  iconReq?: any;
  deleteFileName?: string;
  title?: string;
  tooltip?: string;
  reqComments?: boolean;
  reqDisplayEmail?: boolean;
  reqCategory?: boolean;
}

export interface IWidgetLAF {
  bgColor: string;
  fgColor: string;
  font: string;
  fontWeight: number;
  fontStyle: string;
  text: string;
  icon?: string;
  iconReq?: any;
  position: IWidgetPosition;
  rotation?: string;
  custom?: ICustomProperties;
}

export interface ICustomProperties {
  top?: string;
  bottom?: string;
  left?: string;
  right?: string;
  borderRadius?: string;
  rotation?: string;
  margin?: string;
  padding?: string;
}

export interface IRemoteBtnSettings {
  name: string;
  btnId?: string;
  disable: boolean;
}

export interface ICategory {
  feedbacks?: string[];
  name: string;
  positiveFeedbacks?: string[];
  negativeFeedbacks?: string[];
}

export interface ITrackingSystem {
  feedbackTypes: string[]; //Feedback or bugs or feature req
  configs: {
    [key: string]: ITrackingSystemConfig;
  };
}

export interface ITrackingSystemConfig {
  auth: {
    authUser?: string;
    authKey?: string;
  };
  project?: string;
  defaultSeverity?: string;
  fieldMappings?: any;
  filters?: any;
  comments?: string;
  issueType?: string;
  isToolConnected?: boolean;

  //  severity: boolean;
  type: ITrackingSystemType;
  url?: string;
  //  uploadToTrackingSystem: boolean;
  [key: string]: any;
}
export interface IEmailConfiguration {
  feedbackTypes: string[]; //Feedback or bugs or feature req
  ratingLimit?: {
    [key: string]: boolean;
  };
  severityLimit?: {
    [key: string]: boolean;
  };
  emailText: {
    [key: string]: string; // ex: Feedback : 'Dear customer ....'
  };
  emailSubject: {
    [key: string]: string;
  };
  emailSignature: {
    [key: string]: string;
  };
  emailSalutation: {
    [key: string]: string;
  };
  emailOpeningParagraph: {
    [key: string]: string;
  };
  emailClosingParagraph: {
    [key: string]: string;
  };
}

export interface IProductParams {
  [x: string]: any;
  products: IProductInfo[];
}

export const MAIN_BUTTON = "MainButton";
export const FEEDBACK_OPT = "FeedbackOpt";
export const BUGS_OPT = "BugsOpt";
export const FEATURE_OPT = "FeatureOpt";
export const CHATBOT_ICON_OPT = "ChatbotIconOpt";
export const CHATBOT_SEND_ICON_OPT = "ChatbotSendIconOpt";

export const STATUS_PRODUCT_ACTIVE = "active";
export const STATUS_PRODUCT_DELETED = "deleted";
//export const STATUS_PRODUCT_ARCHIVED = 'archived';

export type IPlatformType = "Web" | "Mobile" | "Tv";
export const PLATFORM_TYPE_BROWSER: IPlatformType = "Web";
export const PLATFORM_TYPE_MOBILE: IPlatformType = "Mobile";
export const PLATFORM_TYPE_TV: IPlatformType = "Tv";
export const PlatformTypesList = [
  {
    name: "Web",
    value: PLATFORM_TYPE_BROWSER,
  },
  {
    name: "Mobile",
    value: PLATFORM_TYPE_MOBILE,
  },
  {
    name: "TV",
    value: PLATFORM_TYPE_TV,
  },
];

export const PlatformTypesListChatBot = [
  {
    name: "Web",
    value: PLATFORM_TYPE_BROWSER,
  },
  {
    name: "Mobile",
    value: PLATFORM_TYPE_MOBILE,
  },
];

export type IFeedbackType =
  | "FEEDBACK"
  | "BUGS"
  | "FEATURE_REQUEST"
  | "BUG_REPORT"
  | "AI_SUPPORT";
export const FEEDBACK_TYPE_FEEDBACK: IFeedbackType = "FEEDBACK";
export const FEEDBACK_TYPE_BUGS: IFeedbackType = "BUGS";
export const FEEDBACK_TYPE_BUG_REPORT: IFeedbackType = "BUG_REPORT";
export const FEEDBACK_TYPE_FEATURE_REQ: IFeedbackType = "FEATURE_REQUEST";
export const FEEDBACK_TYPE_AI_SUPPORT: IFeedbackType = "AI_SUPPORT";

export const FeedbackTypesObj: any = {
  FEEDBACK: "Submit Feedback",
  BUGS: "Submit Tickets",
  FEATURE_REQUEST: "Submit Feature Request",
  // AI_SUPPORT: "Chat and Support",
};

export type IFeedbackFlowType = "STATIC" | "DYNAMIC";
export const FEEDBACK_FLOW_STATIC: IFeedbackFlowType = "STATIC";
export const FEEDBACK_FLOW_DYNAMIC: IFeedbackFlowType = "DYNAMIC";
export const BUG_FLOW_STATIC: IFeedbackFlowType = "STATIC";
export const FEATURE_REQUEST_FLOW_STATIC: IFeedbackFlowType = "STATIC";

export type IRatingIconType = "STAR" | "HEART" | "EMOJI";
export const RATING_ICON_TYPE_STAR: IRatingIconType = "STAR";
export const RATING_ICON_TYPE_HEART: IRatingIconType = "HEART";
export const RATING_ICON_TYPE_EMOJI: IRatingIconType = "EMOJI";

export type IInvokeType = "MANUAL" | "AFTER_DELAY" | "CONTEXT_CHANGE" | "IDLE";
export const INVOKE_TYPE_MANUAL: IInvokeType = "MANUAL";
export const INVOKE_TYPE_AFTER_DELAY: IInvokeType = "AFTER_DELAY";
export const INVOKE_TYPE_CONTEXT_CHANGE: IInvokeType = "CONTEXT_CHANGE";
export const INVOKE_TYPE_IDLE: IInvokeType = "IDLE";

export type ITrackingSystemType = "SELF" | "JIRA" | "ZENDESK";
export const TRACKING_SYSTEM_SELF: ITrackingSystemType = "SELF";
export const TRACKING_SYSTEM_JIRA: ITrackingSystemType = "JIRA";
export const TRACKING_SYSTEM_ZENDESK: ITrackingSystemType = "ZENDESK";

// export type IFeedbotConfigSettingsType = 'CATEGORIES' | 'SEVERITIES' | 'COMMENTS' | 'STANDARD FEEDBACK';
// export const FEEDBOT_CATEGORIES: IFeedbotConfigSettingsType = 'CATEGORIES';
// export const FEEDBOT_SEVERITIES: IFeedbotConfigSettingsType = 'SEVERITIES';
// export const FEEDBOT_COMMENTS: IFeedbotConfigSettingsType = 'COMMENTS';
// export const FEEDBOT_STANDARD_FEEDBACK: IFeedbotConfigSettingsType = 'STANDARD FEEDBACK';

export type IWidgetPosition =
  | "RIGHT_MIDDLE"
  | "RIGHT_BOTTOM"
  | "LEFT_MIDDLE"
  | "LEFT_BOTTOM"
  | "BOTTOM_RIGHT"
  | "BOTTOM_LEFT"
  | "CUSTOM";
export const POS_RIGHT_MIDDLE: IWidgetPosition = "RIGHT_MIDDLE";
export const POS_RIGHT_BOTTOM: IWidgetPosition = "RIGHT_BOTTOM";
export const POS_LEFT_MIDDLE: IWidgetPosition = "LEFT_MIDDLE";
export const POS_LEFT_BOTTOM: IWidgetPosition = "LEFT_BOTTOM";
export const POS_BOTTOM_RIGHT: IWidgetPosition = "BOTTOM_RIGHT";
export const POS_BOTTOM_LEFT: IWidgetPosition = "BOTTOM_LEFT";
export const POS_CUSTOM: IWidgetPosition = "CUSTOM";

export const webTechs = [
  {
    name: "Vanilla Js",
    value: "vanilla",
    logo: images.jslogo,
  },
  {
    name: "jQuery",
    value: "jquery",
    logo: images.jqueryicon,
  },
  {
    name: "React Js",
    value: "react",
    logo: images.reactjs,
  },
  {
    name: "Angular Js",
    value: "angular",
    logo: images.angularjs,
  },
  {
    name: "Vue Js",
    value: "vue",
    logo: images.vuejs,
  },
  {
    name: "Next Js",
    value: "nextjs",
    logo: images.nextjsicon,
  },
  {
    name: "Preact Js",
    value: "preact",
    logo: images.preactlogo,
  },
];
export const mobTechs = [
  // {
  //   name: "React native",
  //   value: "reactNative",
  //   logo: images.reactjs,
  // },
  {
    name: "Android Kotlin",
    value: "androidKotlin",
    logo: images.android,
  },
  {
    name: "Android Java",
    value: "androidJava",
    logo: images.android,
  },
  {
    name: "iOS Swift",
    value: "iosSwift",
    logo: images.ios,
  },
  {
    name: "iOS Objective C",
    value: "iosObjectiveC",
    logo: images.ios,
  },
];

export const mobTechsChatbot = [
  {
    name: "Android Kotlin",
    value: "androidKotlin",
    logo: images.android,
  },
  {
    name: "Android Java",
    value: "androidJava",
    logo: images.android,
  },
  {
    name: "iOS Swift",
    value: "iosSwift",
    logo: images.ios,
  },
  {
    name: "iOS Objective C",
    value: "iosObjectiveC",
    logo: images.ios,
  },
];

export const tvTechs = [
  // {
  //   name: "React native",
  //   value: "reactNativeTv",
  //   logo: images.reactjs,
  // },
  {
    name: "Android Kotlin",
    value: "androidKotlinTv",
    logo: images.androidTv,
  },
  {
    name: "Android Java",
    value: "androidJavaTv",
    logo: images.androidTv,
  },
  // {
  //   name: "tvOS Swift",
  //   value: "tvOSSwiftTv",
  //   logo: images.appleTv,
  // },
  // {
  //   name: "tvOS Objective C",
  //   value: "tvosObjectiveCTv",
  //   logo: images.appleTv,
  // },
  // {
  //   name: "Samsung",
  //   value: "samsungTv",
  //   logo: images.samsungtv,
  // },
  // {
  //   name: "LG",
  //   value: "lgTv",
  //   logo: images.lgTv,
  // },
  // {
  //   name: "Amazon",
  //   value: "amazonTv",
  //   logo: images.amazonTv,
  // },
  {
    name: "ROKU",
    value: "rokuTv",
    logo: images.amazonTv, //images.rokuTv,
  },
  // {
  //   name: "HTML5",
  //   value: "html5Tv",
  //   logo: images.html5Tv, //images.rokuTv,
  // },
  {
    name: "HTML5 ReactJs",
    value: "html5ReactJs",
    logo: images.html5Tv, //images.rokuTv,
  },
  // {
  //   name: "HTML5 VanillaJs",
  //   value: "html5VanillaJs",
  //   logo: images.html5Tv, //images.rokuTv,
  // }
];

export const TYPE_IMAGE = "Image";
export const TYPE_TEXT = "Text";
export const TYPE_NONE = "None";

export const BannerTypeList = [
  {
    name: "Image",
    value: TYPE_IMAGE,
  },
  {
    name: "Text",
    value: TYPE_TEXT,
  },
  {
    name: "None",
    value: TYPE_NONE,
  },
];
